@if (!linked) {
    <ng-container>
        <div class="fancy-loader"></div>
    </ng-container>
}

<div class="detail-page-card" data-uiid="forms-linkable">
    <div class="detail-page-card-title">{{ 'formLinkable.linkedFormsTitle' | t }}</div>
    <div class="detail-page-card-actions">
        @if (!disabled) {
            <button class="btn btn-raised" (click)="openLinkPopup()" data-uiid="button-link-form">
                <i class="fas fa-link"></i>
                <span class="d-none d-lg-inline">{{ 'formLinkable.linkBtn' | t }}</span>
            </button>
        }
    </div>
</div>

@if (linked.length > 0) {
    <div class="all-forms overview-content">
        <div class="detail-page-card">
            <div class="detail-page-card-body padded">
                <ul class="form-cards">
                    @for (item of linked; track item) {
                        <li
                            class="card"
                            [ngClass]="{ clickable: item.hasAccess }"
                            data-uiid="linked-form-preview"
                            (click)="openForm(item)"
                        >
                            <div
                                class="card-img-top main"
                                [style.backgroundImage]="
                                    'url(' +
                                    (item.imageGuid
                                        ? 'api/forms/thumbnail/' + item.imageGuid
                                        : '/static/images/form_logo_fallback.jpg') +
                                    ')'
                                "
                            ></div>
                            <div class="card-body">
                                <h5 class="card-title" data-uiid="linked-form-name">
                                    {{ item.name }}
                                    @if (!item.hasAccess) {
                                        <i class="fas fa-lock ms-2 font-weight-normal"></i>
                                    }
                                </h5>
                                <p class="card-text" title="{{ item.description }}">
                                    {{ item.description }}
                                </p>
                            </div>
                        </li>
                    }
                </ul>
            </div>
        </div>
    </div>
}
<ng-template #linkTemplate>
    <app-linkable
        typename="forms"
        [displayValueProp]="displayValueProp"
        [linked]="linked"
        [unlinked]="unlinked"
        [orderByValueProperty]="true"
        [disabled]="disabled"
        [hideActions]="hideActions"
        [hideFilter]="hideFilter"
        [allowAddNew]="allowAddNew"
        [cleanSpacers]="cleanSpacers"
        [rowIconConfig]="rowIconConfig"
        [allowEditItem]="allowEditItem"
        [allowBatchEdit]="allowBatchEdit"
    ></app-linkable>
</ng-template>
